export default function BIMProjectLogo(props) {
    return (
        <svg
            width="131"
            height="149"
            viewBox="0 0 131 149"
            xmlns="http://www.w3.org/2000/svg"
            { ...props }
        >
            <g>
                <path
                    d="M 65.364 148.743 C 62.918 148.743 60.538 147.475 59.226 145.203 C 57.271 141.817 58.431 137.486 61.818 135.533 L 120.095 101.885 C 123.48 99.931 127.811 101.093 129.766 104.479 C 131.72 107.865 130.56 112.193 127.174 114.149 L 68.898 147.793 C 67.782 148.438 66.566 148.743 65.364 148.743"
                    fill="currentColor"
                />
                <path
                    d="M 36.226 64.63 C 33.779 64.63 31.399 63.359 30.087 61.089 C 28.134 57.702 29.294 53.373 32.679 51.418 L 90.956 17.771 C 94.342 15.818 98.672 16.978 100.627 20.363 C 102.583 23.75 101.422 28.079 98.035 30.034 L 39.759 63.681 C 38.644 64.325 37.427 64.63 36.226 64.63"
                    fill="currentColor"
                />
                <path
                    d="M 117.264 51.489 C 114.818 51.489 112.438 50.218 111.126 47.947 C 109.171 44.561 110.331 40.231 113.718 38.277 L 120.095 34.595 C 123.482 32.641 127.811 33.799 129.766 37.186 C 131.72 40.571 130.56 44.902 127.175 46.857 L 120.796 50.539 C 119.682 51.182 118.464 51.489 117.264 51.489"
                    fill="currentColor"
                />
                <path
                    d="M 65.364 81.451 C 62.918 81.451 60.538 80.182 59.226 77.911 C 57.271 74.525 58.431 70.197 61.818 68.239 L 93.252 50.093 C 96.639 48.138 100.968 49.297 102.923 52.683 C 104.878 56.069 103.718 60.399 100.332 62.354 L 68.898 80.502 C 67.782 81.147 66.566 81.451 65.364 81.451"
                    fill="currentColor"
                />
                <path
                    d="M 58.987 17.843 C 56.54 17.843 54.16 16.574 52.848 14.302 C 50.894 10.917 52.054 6.586 55.44 4.631 L 61.818 0.95 C 65.204 -1.005 69.534 0.155 71.488 3.541 C 73.444 6.927 72.283 11.258 68.898 13.211 L 62.52 16.894 C 61.404 17.538 60.188 17.843 58.987 17.843"
                    fill="currentColor"
                />
                <path
                    d="M 7.088 81.451 C 4.642 81.451 2.26 80.182 0.948 77.911 C -1.004 74.525 0.155 70.197 3.54 68.239 L 9.92 64.558 C 13.306 62.603 17.635 63.763 19.588 67.149 C 21.544 70.537 20.386 74.867 16.999 76.821 L 10.62 80.502 C 9.506 81.147 8.288 81.451 7.088 81.451"
                    fill="currentColor"
                />
                <path
                    d="M 36.227 131.921 C 33.78 131.921 31.399 130.65 30.088 128.379 C 28.134 124.994 29.292 120.665 32.679 118.707 L 39.058 115.027 C 42.444 113.071 46.774 114.231 48.727 117.618 C 50.682 121.003 49.523 125.335 46.138 127.289 L 39.758 130.971 C 38.643 131.615 37.426 131.921 36.227 131.921"
                    fill="currentColor"
                />
                <path
                    d="M 7.088 47.807 C 4.642 47.807 2.26 46.537 0.948 44.265 C -1.004 40.879 0.155 36.549 3.54 34.594 L 34.976 16.447 C 38.363 14.491 42.692 15.651 44.646 19.038 C 46.6 22.425 45.442 26.755 42.056 28.709 L 10.62 46.858 C 9.506 47.502 8.288 47.807 7.088 47.807"
                    fill="currentColor"
                />
                <path
                    d="M 7.088 115.097 C 4.642 115.097 2.26 113.827 0.948 111.557 C -1.004 108.171 0.155 103.842 3.54 101.885 L 40.284 80.587 C 43.671 78.633 48.003 79.793 49.956 83.179 C 51.912 86.566 50.752 90.895 47.366 92.85 L 10.62 114.147 C 9.506 114.793 8.288 115.097 7.088 115.097"
                    fill="currentColor"
                />
                <path
                    d="M 65.364 115.097 C 62.918 115.097 60.538 113.827 59.226 111.558 C 57.271 108.171 58.431 103.842 61.818 101.887 L 120.095 68.241 C 123.48 66.287 127.811 67.446 129.766 70.833 C 131.72 74.218 130.56 78.546 127.174 80.503 L 68.898 114.147 C 67.782 114.793 66.566 115.097 65.364 115.097"
                    fill="currentColor"
                />
            </g>
        </svg>
    );
}
